(function () {
  'use strict';

  // CHG-2026-114. A horizontal gesture changes the slide only after this much
  // travel, and only when it is clearly horizontal. The slope test matters: a
  // reader scrolling the page past the banner will never be perfectly vertical,
  // and without it a slightly angled scroll flips the banner under their thumb.
  var SWIPE_MIN = 45;
  var SWIPE_SLOPE = 1.2;

  document.querySelectorAll('[data-pf-hero]').forEach(function (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-pf-hero-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-pf-hero-dot]'));
    var current = 0;
    var timer = null;
    var autoplay = hero.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = Math.max(4000, Number(hero.dataset.interval) || 6000);
    var startX = 0;
    var startY = 0;
    var tracking = false;
    var pointerId = null;
    var suppressClick = false;
    if (slides.length < 2) return;

    function show(index, userInitiated, direction) {
      // CHG-2026-115. A direction means this is a real move between slides. The
      // first render passes none, so nothing animates and nothing is armed.
      var animate = direction === 'next' || direction === 'prev';
      current = (index + slides.length) % slides.length;
      // Read by the stylesheet to pick which side the arriving slide travels
      // from. Set before the classes flip so the animation starts on the correct
      // side; the outgoing slide ignores it because it only fades in place.
      if (animate) hero.setAttribute('data-pf-dir', direction);
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelectorAll('a, button, input, select, textarea').forEach(function (control) {
          control.tabIndex = active ? 0 : -1;
        });
      });
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      // Armed here, after the classes have flipped. Arming it at start-up left
      // the first banner static for one frame and then sliding in, because the
      // first slide is already `is-active` when the attribute lands - the exact
      // opposite of an entrance that only plays once the reader moves.
      if (animate) hero.setAttribute('data-pf-anim', '');
      if (userInitiated) restart();
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!autoplay || document.hidden) return;
      timer = window.setInterval(function () { show(current + 1, false, 'next'); }, interval);
    }

    function restart() { stop(); start(); }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        show(index, true, index < current ? 'prev' : 'next');
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', function (event) { if (!hero.contains(event.relatedTarget)) start(); });
    document.addEventListener('visibilitychange', start);

    /*
     * Swipe. Pointer events cover touch and pen with one listener set. Mouse is
     * deliberately excluded: a drag on the banner fights text selection and image
     * dragging, and on a desktop the dots are the expected control, so the user
     * asked to leave mouse out.
     */
    hero.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' || !event.isPrimary) return;
      // Never start a swipe on something that is itself clickable, or releasing
      // a drag would fight the dot or the CTA.
      if (event.target && event.target.closest && event.target.closest('a, button, input, select, textarea')) return;
      startX = event.clientX;
      startY = event.clientY;
      pointerId = event.pointerId;
      tracking = true;
      suppressClick = false;
      stop();
    });

    hero.addEventListener('pointerup', function (event) {
      if (!tracking || event.pointerId !== pointerId) return;
      tracking = false;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      var horizontal = Math.abs(dx) >= SWIPE_MIN && Math.abs(dx) >= Math.abs(dy) * SWIPE_SLOPE;
      if (!horizontal) { start(); return; }
      // The gesture ended over the banner, and most of the banner is a link, so
      // exactly one click is swallowed below to stop the CTA firing.
      suppressClick = true;
      show(current + (dx < 0 ? 1 : -1), true, dx < 0 ? 'next' : 'prev');
    });

    hero.addEventListener('pointercancel', function () {
      if (!tracking) return;
      tracking = false;
      start();
    });

    hero.addEventListener('click', function (event) {
      if (!suppressClick) return;
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    // No direction on purpose: the first slide is already `is-active` in the
    // markup, so this only syncs state and arms nothing.
    show(0, false, null);
    start();
  });
})();
